import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] caught error:', error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.hasError) {
      const message = this.state.error?.message || String(this.state.error || '未知错误');
      return (
        <div style={{ padding: 20, margin: '20px auto', maxWidth: 900 }}>
          <div style={{
            borderRadius: 12,
            border: '1px solid rgba(0,0,0,0.1)',
            background: 'rgba(255,255,255,0.95)',
            boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
            padding: 18
          }}>
            <div style={{ fontSize: 18, fontWeight: 900, marginBottom: 8, color: '#b71c1c' }}>
              页面出现错误，已被拦截（避免白屏）
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 10, color: '#263238' }}>
              {message}
            </div>
            <div style={{ fontSize: 13, color: '#546e7a', lineHeight: 1.6 }}>
              你可以刷新页面重试；如果持续出现，把这里的错误信息截图发我，我会继续修复。
            </div>
            {this.state.error?.stack && (
              <pre style={{
                marginTop: 12,
                padding: 12,
                borderRadius: 10,
                background: '#0b1020',
                color: '#d7e3ff',
                fontSize: 12,
                overflow: 'auto'
              }}>
{this.state.error.stack}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

